export default __webpack_public_path__ + "static/media/Nanos_Abenteuer_Hoerprobe.6e8114a9.mp3";